/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';

export const getRequiredLabel = (label, isRequired) => (
  <span className='custom-required-label-class'>
    {label}
    {isRequired && (
      <span
        css={css`
          color: rgb(164, 38, 44);
        `}
      >
        {' *'}
      </span>
    )}
  </span>
);
